import ProductCategoryPanel from './productCategoryPanel.container';

export default ProductCategoryPanel;